import { Button } from '@resy/ui-kitchen';
import React from 'react';

const CalendarCloseButton = () => (
  <Button variant="close" />
);
CalendarCloseButton.displayName = 'CalendarCloseButton';
export default CalendarCloseButton;
